import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducers/userSlice";
import gymDataReducer from "./reducers/gymDataSlice";
import trainersDataReducer from "./reducers/trainerDataSlice";
import assigneeDataReducer from "./reducers/assigneeDataSlice";
import { settlementFormReducer } from "./reducers/settlementFormSlice";
import apiReducer from "./reducers/apiSlice";
import { clickedRowReducer } from "./reducers/settlementFormSlice";
import filtersReducer from "./reducers/filtersSlice";
import postApiReducer from "./reducers/postApiSlice";
import putApiReducer from "./reducers/putApiSlice";
import deleteApiReducer from "./reducers/deleteApiSlice";
import workoutReducer from "./workout-reducers/workoutApis";
import websiteReducer from "./website-reducers/websiteSlice";
import hygieneReducer from "./hygiene-reducers/hygieneSlice";
import tabsReducer from "./reducers/tabsSlice";
import authReducer from "./reducers/authSlice";
import sidebarReducer from "./reducers/sidebar";
import dropdownApiReducer from "./reducers/dropdownApiSlice";
import incentivesReducer from "./incentives-reducers/incentivesSlice";
import commonApiReducer from "./reducers/commonApiSlice";
import notificationReducer from "./reducers/notificationSlice";
import plansReducer from "./plans-reducers/plansSlice";
import ptPlansReducer from "./plans-reducers/ptPlansSlice";
import prospectReducer from "./prospect-reducers/prospectSlice";
import paymentReducer from "./payment-reducerss/paymentSlice";
import blogReducer from "./ad-blog-reducers/blogSlice";
import featureReducer from "./dashboard-features/featuresSlice";
import transferReducer from "./transfer-reducers/transferSlice";
import payroleReducer from "./payrole-reducers/payroleSlice";
import ticketSystemReducer from "./reducers/ticketSystemSlice";
import liveReducer from "./live-reducers/liveSlice";
import emailBroadcastReducer from "./email-broadcast/emailBroadcastSlice";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "authUser",
  storage,
};

const persistedReducer = persistReducer(persistConfig, authReducer);

export const store = configureStore({
  reducer: {
    user: userReducer,
    gymData: gymDataReducer,
    trainersData: trainersDataReducer,
    assigneeData: assigneeDataReducer,
    settlementForm: settlementFormReducer,
    api: apiReducer,
    clickedRow: clickedRowReducer,
    filters: filtersReducer,
    postApi: postApiReducer,
    putApi: putApiReducer,
    delApi: deleteApiReducer,
    workoutApi: workoutReducer,
    webApi: websiteReducer,
    hygiene: hygieneReducer,
    tabs: tabsReducer,
    auth: persistedReducer,
    sidebar: sidebarReducer,
    dropdown: dropdownApiReducer,
    common: commonApiReducer,
    incentives: incentivesReducer,
    notification: notificationReducer,
    plans: plansReducer,
    ptPlans: ptPlansReducer,
    prospects: prospectReducer,
    payment: paymentReducer,
    blog: blogReducer,
    features: featureReducer,
    transfer: transferReducer,
    payrole: payroleReducer,
    ticketSystem: ticketSystemReducer,
    live: liveReducer,
    emailBroadcast: emailBroadcastReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
